import { NodeCard } from './CustomNode.styles.tsx';
import { Position, Edge } from 'reactflow';
import { Typography } from '@mui/material';
import { WorkflowNodeType } from '../../../../api/model.ts';
import { NodeProps } from '../../../../types.ts';
import { getNodeConfig } from '../../../../api/workflows-steps/formSchema.tsx';
import { EdgeHandle } from '../common/EdgeHandle.tsx';
import { useMemo } from 'react';

type FormNodeData = {
  name?: string;
  requiredConnection?: keyof Edge;
  highlightColor: string;
  edges?: Edge[];
  source?: boolean;
  target?: boolean;
};

export type FormNodeProps = NodeProps & {
  data: FormNodeData;
};

const FormNode = ({ id, type, data, isConnectable }: FormNodeProps) => {
  const { color, icon, name: nodeTypeName } = getNodeConfig(type as WorkflowNodeType)!;
  const nodeName: string = data.name ?? nodeTypeName;

  const isMissingRequiredConnection = useMemo(() => {
    if (!data.requiredConnection) return false;
    return !data.edges?.some((edge: Edge) => edge[data.requiredConnection!] === id);
  }, [data.edges, data.requiredConnection, id]);

  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <NodeCard
          color={color}
          className="relative overflow-visible"
          elevation={0}
          error={isMissingRequiredConnection}
          highlightColor={data.highlightColor}
        >
          {icon}
          {data.source && <EdgeHandle type="source" position={Position.Right} isConnectable={isConnectable} />}
          {data.target && <EdgeHandle type="target" position={Position.Left} isConnectable={isConnectable} />}
        </NodeCard>
        <Typography
          className="absolute whitespace-nowrap"
          style={{
            bottom: '-25px',
          }}
        >
          {nodeName}
        </Typography>
      </div>
    </>
  );
};

export default FormNode;
